module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-763w.9a6edb75.webp";